// menu.tsx (your MENUITEMS file)
import { Icons } from "./Icons";

export const MENUITEMS = [
  {
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Dashboard",
        icon: Icons.Dashboard,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/dashboard`,
        active: false,
        actions: ["dashboard:view"],
      },
      {
        title: "Provisioning",
        icon: Icons.Customers,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/provisioning`,
        active: false,
        // TODO: swap for a dedicated "provisioning:view" permission once seeded.
        actions: ["dashboard:view"],
      },
      {
        title: "Renew / Change Plan",
        icon: Icons.ManagePlans,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/renewal`,
        active: false,
        // TODO: swap for a dedicated "renewal:manage" permission once seeded.
        actions: ["dashboard:view"],
      },
      {
        title: "Communication Config",
        icon: Icons.CommunicationConfig,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/configuration`,
        active: false,
        actions: ["configuration:view"],
      },
      {
        title: "Users",
        icon: Icons.Users,
        type: "sub",
        children: [
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/users`,
            title: "Users",
            type: "link",
            icon: Icons.Users,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/permission-management`,
            title: "Permission Management",
            type: "link",
            icon: Icons.Permission,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/roles`,
            title: "Role Management",
            type: "link",
            icon: Icons.Roles,
          },
        ],
        actions: [
          "users:view",
          "users:create",
          "users:edit",
          "users:delete",
          "users:export",
          // "permission_management:view",
          // "permission_management:create",
          // "permission_management:delete",
          // "roles:view",
          // "roles:create",
          // "roles:edit",
          // "roles:delete"
        ],
      },
      {
        title: "Customers",
        icon: Icons.Customers,
        type: "sub",
        children: [
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/customers`,
            title: "Customers",
            type: "link",
            icon: Icons.Customers,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/customers-member-benefit`,
            title: "Customers Member Benefit",
            type: "link",
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/direct-customer-upload`,
            title: "Direct Customer Upload",
            type: "link",
          },
        ],
        actions: ["customers:view", "customers:upload"],
      },
      {
        title: "Program Module",
        icon: Icons.ProgramModule,
        type: "sub",
        children: [
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/manage-clients`,
            title: "Manage Clients",
            type: "link",
            icon: Icons.ManageClients,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/membership-plans`,
            title: "Membership Plans",
            type: "link",
            icon: Icons.ManagePlans,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/programs`,
            title: "Manage Plans",
            type: "link",
            icon: Icons.ManagePlans,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/manage-bcc-mail`,
            title: "Manage BCC Mail",
            type: "link",
            icon: Icons.ManageBCC,
          },
          {
            active: false,
            path: `${process.env.PUBLIC_URL}/pages/manage-addon-services`,
            title: "Manage Add-on Services",
            type: "link",
            icon: Icons.ManagePlans,
          },
        ],
        actions: ["programModule:view"],
      },
      {
        title: "Service Grouping",
        icon: Icons.ServiceGrouping,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/service-grouping`,
        actions: ["serviceGrouping:view"],
      },
      {
        title: "Sub Services",
        icon: Icons.SubServices,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/sub-services`,
        actions: ["services:view"],
      },
      {
        title: "Service Categories",
        icon: Icons.ServiceCategories,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/service-categories`,
        actions: ["serviceCategories:view"],
      },
      {
        title: "Sub Categories",
        icon: Icons.SubCategories,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/service-sub-categories`,
        actions: ["serviceSubCategories:view"],
      },
      {
        title: "Commercials",
        icon: Icons.Commercials,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/commercials`,
        actions: ["commercials:view"],
      },
      {
        title: "Blogs",
        icon: Icons.Blogs,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/blogs`,
        actions: ["blogs:view"],
      },
      {
        title: "Products",
        icon: Icons.Products,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/prodcuts-collections`,
        actions: ["products:view"],
      },
      {
        title: "Manage Vendors",
        icon: Icons.ManageVendors,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/manage-vendors`,
        actions: ["vendors:view"],
      },
      {
        title: "Form Management",
        icon: Icons.FormManagement,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/form-management`,
        actions: ["form:view"],
      },
      {
        title: "Get In Touch",
        icon: Icons.Customers,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/get-in-touch`,
        actions: ["customers:view"],
      },
      {
        title: "Failed Credit Services",
        icon: Icons.FileText,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/failed-credit-services`,
        actions: ["customers:view"],
      },
      {
        path: `${process.env.PUBLIC_URL}/pages/newsletter`,
        icon: Icons.Customers,
        title: "Newsletter",
        type: "link",
        actions: ["customers:view"],
      },
    ],
  },
];
